/* ==========================================================================
   HOUND - cart line errors, written where they can be read
   ==========================================================================
   When the cart refuses a quantity change (the raffle gate: "Sign in to your
   HOUND account to check out with this piece.", early access, a stock rule),
   the theme's cart.js calls setCustomValidity + reportValidity on the quantity
   input. That shows a browser tooltip for a few seconds and nothing else, so
   the reason is easy to miss and gone once it fades.

   This listens for the resulting `invalid` event on a cart or drawer quantity
   input and also writes the same message under the row, as a role=alert line
   (styles in assets/hound-cart.css, .hcg-line-error). It changes nothing about
   what the cart does: no requests, no values, the theme still resets the input.
   The cart re-renders the row on the next successful change, which clears it.
   ========================================================================== */
(function () {
  'use strict';

  function holder(input) {
    var row = input.closest('.cart-item, .horizontal-product');
    if (!row) return null;
    var cell = input.closest('.cart-item__quantity, .horizontal-product__quantity') || row;
    var el = cell.querySelector('.hcg-line-error');
    if (!el) {
      el = document.createElement('p');
      el.className = 'hcg-line-error';
      el.setAttribute('role', 'alert');
      el.hidden = true;
      cell.appendChild(el);
    }
    return el;
  }

  document.addEventListener('invalid', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('.quantity__input')) return;
    if (!input.closest('cart-drawer, .cart')) return;
    var msg = input.validationMessage;
    var el = holder(input);
    if (!el || !msg) return;
    el.textContent = msg;
    el.hidden = false;
  }, true);

  /* A later edit to the same input clears the old reason. */
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('.quantity__input')) return;
    var row = input.closest('.cart-item, .horizontal-product');
    var el = row && row.querySelector('.hcg-line-error');
    if (el) el.hidden = true;
  }, true);
})();
